import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../../../components/Header';
import Sidebar from '../../../../components/Sidebar';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import { ExerciseValidationSchema } from '../../../../utils/FormValidation';
import { useDispatch, useSelector } from 'react-redux';
import { InputFromUser } from '../../../../components/Input/input';
import { SubmitButton } from '../../../../components/Button';
import {
  ActionCreateExercise,
  ActionGetExerciseList,
  ActionUpdateExercise,
} from '../../../../store/Actions/MasterDataAction';

const Add_Exercise = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const url = new URL(window.location.href);
  const searchParams = url.searchParams;
  const updateValue = searchParams.get('update');
  const pageValue = searchParams.get('page') || 1;
  const idValue = searchParams.get('id');

  const isEditMode = Boolean(updateValue && idValue);

  useEffect(() => {
    if (idValue) {
      dispatch(ActionGetExerciseList({ Query: `/${idValue}` }));
    }
  }, [idValue, dispatch]);

  const { exercise } = useSelector(state => state?.MasterData);

  const handleSubmitCreate = (values, { setSubmitting, setErrors }) => {
    dispatch(
      ActionCreateExercise(
        {
          orderIndex: values.orderIndex,
          title: values.title,
        },
        Res => {
          setSubmitting(false);
          if (Res?.statusCode === 200) {
            navigate(`/exercise?page=${pageValue}`);
          } else if (Res?.statusCode === 400) {
            setErrors(Res?.data?.errors || {});
          } else {
            alert(Res?.message || 'Something went wrong. Please try again.');
          }
        }
      )
    );
  };

  const handleSubmitUpdate = (values, { setSubmitting, setErrors }) => {
    dispatch(
      ActionUpdateExercise(
        {
          Query: '/' + idValue,
          obj: {
            orderIndex: values.orderIndex,
            title: values.title,
          },
        },
        Res => {
          setSubmitting(false);
          if (Res?.statusCode === 200) {
            navigate(`/exercise?page=${pageValue}`);
          } else if (Res?.statusCode === 400) {
            setErrors(Res?.data?.errors || {});
          } else {
            alert(Res?.message || 'Something went wrong. Please try again.');
          }
        }
      )
    );
  };

  const handleFormSubmit = (values, formikHelpers) => {
    if (!isEditMode) {
      handleSubmitCreate(values, formikHelpers);
    } else {
      handleSubmitUpdate(values, formikHelpers);
    }
  };

  return (
    <>
      <Header />
      <Sidebar />
      <>
        <div>
          <div className="page-wrapper">
            <div className="content">
              {/* Page Header */}
              <div className="page-header">
                <div className="row">
                  <div className="col-sm-12">
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/exercise">Exercise</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <i className="feather-chevron-right">
                          <FeatherIcon icon="chevron-right" />
                        </i>
                      </li>
                      <li className="breadcrumb-item active">
                        {isEditMode ? 'Edit Exercise' : 'Add Exercise'}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="row">
                <div className="col-sm-12">
                  <div className="card p-3">
                    <div className="card-body">
                      <Formik
                        enableReinitialize={isEditMode}
                        initialValues={{
                          orderIndex: exercise?.orderIndex || '',
                          title: exercise?.title || '',
                        }}
                        validationSchema={ExerciseValidationSchema}
                        onSubmit={handleFormSubmit}
                      >
                        {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          isSubmitting,
                        }) => {
                          return (
                            <form onSubmit={handleSubmit}>
                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="form-heading">
                                    <h4>
                                      {isEditMode
                                        ? 'Edit Exercise Data'
                                        : 'Add Exercise Data'}
                                    </h4>
                                  </div>
                                </div>

                                <div className="d-flex">
                                  <InputFromUser
                                    placeholder={'Order Index'}
                                    type="number"
                                    name="orderIndex"
                                    onChange={handleChange}
                                    FormGroupClassName={'col-xl-6 col-md-12'}
                                    LabelClassName={'col-form-label'}
                                    onBlur={handleBlur}
                                    value={values.orderIndex}
                                    label="Order Index"
                                    error={errors?.orderIndex}
                                    touched={touched.orderIndex}
                                  />
                                </div>
                                <InputFromUser
                                  placeholder={'Title'}
                                  type="text"
                                  name="title"
                                  onChange={handleChange}
                                  FormGroupClassName={'col-xl-6 col-md-12'}
                                  LabelClassName={'col-form-label'}
                                  onBlur={handleBlur}
                                  value={values.title}
                                  label="Title"
                                  error={errors?.title}
                                  touched={touched.title}
                                />

                                <div className="col-12 mt-4">
                                  <div className="doctor-submit text-end">
                                    <SubmitButton
                                      htmlType="button"
                                      onClick={handleSubmit}
                                      className="btn btn-primary submit-form me-2"
                                      loading={isSubmitting}
                                    >
                                      {isEditMode ? 'Update' : 'Submit'}
                                    </SubmitButton>
                                    <button
                                      type="button"
                                      className="btn btn-primary cancel-form"
                                      onClick={() =>
                                        navigate(`/exercise?page=${pageValue}`)
                                      }
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          );
                        }}
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default Add_Exercise;
